import { render, staticRenderFns } from "./createService.vue?vue&type=template&id=8f4f2ba4&scoped=true"
import script from "./createService.vue?vue&type=script&lang=js"
export * from "./createService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4f2ba4",
  null
  
)

export default component.exports